import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthFooterControls } from '@/components/auth/AuthFooterControls'
import { AuthPageShell } from '@/components/auth/AuthPageShell'
import { type RegisterCredentials, RegisterFormView } from '@/components/auth/RegisterFormView'
import { useAuth } from '@/contexts/AuthContext'
import { ApiError } from '@/services/api/client'

export default function RegisterPage() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [registrationClosed, setRegistrationClosed] = useState(false)

  const { register } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (credentials: RegisterCredentials) => {
    setError('')
    setIsLoading(true)

    try {
      await register(credentials)

      // Redirect to login after successful registration
      navigate('/login')
    } catch (error) {
      // Check if registration is closed (403 error)
      if (error instanceof ApiError && error.status === 403) {
        setRegistrationClosed(true)
        setError('')
      } else {
        // Other errors - show generic error message
        setError(error instanceof Error ? error.message : 'Registration failed')
        setRegistrationClosed(false)
      }
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AuthPageShell>
      <RegisterFormView
        loading={isLoading}
        registrationClosed={registrationClosed}
        error={error}
        onSubmit={handleSubmit}
        onValidationError={setError}
      />

      <AuthFooterControls />
    </AuthPageShell>
  )
}
